/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Header from "../Common/Navbar";
import { Link } from "react-router-dom";
import { fetchApi } from "../utlis/axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import Loader from "../animation/Loader.json";
import { AuthWrapper } from "../AuthWrapper";
import { FaSearch } from "react-icons/fa";
import Pagination from "./Pagination";
import { MemberRegistration } from "../RegistrationForms/MemberRegistration";

export const MemberListingpage = () => {
  const [memberData, setMemberData] = useState([]);
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(null);
  const [isPopupOpen, setPopupOpen]=useState(false)
  const navigate = useNavigate();

  const getMemberData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(`member/?search=${searchQuery}`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        setMemberData(result?.data);
        console.log("result data", result?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log({ error });
    }
  };

  useEffect(() => {
    getMemberData();
  }, [searchQuery, access]);

  const handleTableRowClick = (id) => {
    console.log("Clicked on row with data:", id);
    navigate(`/memberlistingdetail/${id}`);
  };

  const itemsPerPage = 10;
  const totalPages = Math.ceil(memberData.count / itemsPerPage);

  const fetchDataForPage = async (pageNumber) => {
    const newOffset = (pageNumber - 1) * itemsPerPage;

    try {
      const result = await fetchApi.get(
        `member/?limit=${itemsPerPage}&offset=${newOffset}&page=${pageNumber}&pageSize=${itemsPerPage}&search=${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${access}`,
          },
        }
      );

      return result;
    } catch (error) {
      throw error;
    }
  };

  const handlePageClick = (pageNumber) => {
    console.log("pageNumbber", pageNumber);
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
      setIsLoading(true);

      fetchDataForPage(pageNumber)
        .then((result) => {
          if (result.status === 200) {
            setMemberData(result?.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const nextPageData = () => handlePageClick(currentPage + 1);
  const prevPageData = () => handlePageClick(currentPage - 1);

 

  return (
    <AuthWrapper>
      <>
        <Header parent={'family'}/>

        <div className="w-full px-[16px] md:px-10 min-h-screen md:mt-32 mt-28 max-w-screen-xl mx-auto">
          {/* Top Section */}
          <div className="flex items-center justify-between gap-3 mt-6 md:mb-8 mb-3">
            {/* Search */}
            <div className="relative flex justify-center border rounded-full sm:py-2 py-[4px] px-2 sm:w-[400px] w-full bg-[#FCFBF7] items-center gap-2">
              <FaSearch className="text-gray-500" />
              <input
                type="search"
                name="search"
                className="w-full outline-none text-gray-600 py-1 px-1 bg-transparent"
                placeholder="Search here...."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <div className="flex items-center gap-4">
              {/* Register Member */}
              <div>
                <span className="sm:text-base text-sm font-medium primary-button" onClick={()=>setPopupOpen(true)}>
                  Register Member
                </span>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="overflow-x-auto bg-white rounded-[20px] border border-gray-border">
            <table className="min-w-full border-collapse ">
              <thead>
                <tr className="bg-primary-green text-white text-left">
                  <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap ">
                    Name
                  </th>
                  <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                    Education
                  </th>
                  <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                    Monthly Income
                  </th>
                  <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                    Medical Condition
                  </th>
                  <th className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs sm:text-sm font-semibold md:text-base whitespace-nowrap">
                    Family
                  </th>
                </tr>
              </thead>

              <tbody className="">
                {isLoading ? (
                  <tr>
                    <td colSpan={5} className="h-[60vh]">
                      <div className="flex justify-center items-center h-full w-full">
                        <Lottie
                          loop={true}
                          animationData={Loader}
                          style={{ width: "200px" }}
                          className="auth-sidebar-video"
                        />
                      </div>
                    </td>
                  </tr>
                ) : memberData?.results?.length > 0 ? (
                  memberData?.results?.map((data, index) => (
                    <tr
                      key={index}
                      className={`cursor-pointer ${
                        index % 2 === 0 ? "bg-white" : "bg-[#219D8014]"
                      } hover:bg-gray-200`}
                      onClick={() => handleTableRowClick(data?.id)}
                    >
                      <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                        {data?.first_name}
                      </td>
                      <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate capitalize">
                        {data?.education_or_qualification}
                      </td>
                      <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                        {data?.monthly_income}
                      </td>
                      <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                        {data?.medical_condition}
                      </td>
                      <td className="py-[8px] md:py-4 md:px-4 px-[8px] text-xs font-normal md:text-base whitespace-nowrap truncate">
                        {data?.family?.name}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="p-4 text-center">
                      No items found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="flex justify-center items-center mt-6">
            <Pagination
              currentPage={currentPage}
              handlePageClick={handlePageClick}
              totalPages={totalPages}
            />
          </div>
        </div>
      </>
      {
        isPopupOpen && <MemberRegistration setShowModal={setPopupOpen}/>
      }
    </AuthWrapper>
  );
};